import { render, staticRenderFns } from "./handSign.vue?vue&type=template&id=066db0a7&scoped=true"
import script from "./handSign.vue?vue&type=script&lang=js"
export * from "./handSign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066db0a7",
  null
  
)

export default component.exports